import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import "./payment.css";







function Payment() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
  });
  const [category, setCategory] = useState("");
  const [amount, setAmount] = useState(0);
  const [orderId] = useState(uuidv4());
  const [currency, setCurrency] = useState("LKR");
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);

  // Check if PayHere SDK is loaded
  useEffect(() => {
    const checkPayhere = () => {
      if (!window.payhere) {
        console.error("PayHere SDK not loaded");
        setError("Payment system not available. Please try again later.");
      }
    };

    // Check after a short delay to allow script to load
    const timer = setTimeout(checkPayhere, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setCategory(selectedCategory);

    switch (selectedCategory) {
      case "International Participant":
        setAmount(120);
        setCurrency("USD");
        break;
      case "SARC Participant":
        setAmount(100);
        setCurrency("USD");
        break;
      case "SriLankan Participant":
        setAmount(25000);
        setCurrency("LKR");
        break;
      case "SriLankan Participant- 01 Day":
        setAmount(15000);
        setCurrency("LKR");
        break;
      case "Student Registration":
        setAmount(20000);
        setCurrency("LKR");
        break;
      default:
        setAmount(0);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  



  const handlePayment = async () => {
    setIsProcessing(true);
    setError(null);
  
    try {
        const response = await fetch("https://eyecare2027.com/api/payment.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            order_id: orderId,
            amount,
            currency,
            customer: {
              firstName: formData.firstName,
              email: formData.email,
            },
          }),
        });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || "Payment initiation failed");
      }
  
      // Configure PayHere payment
      window.payhere.startPayment({
        sandbox: false, // Set this to false in production
        merchant_id: data.merchant_id,
        return_url: `${window.location.origin}/success?order_id=${orderId}`,
        cancel_url: `${window.location.origin}/cancel?order_id=${orderId}`,
        notify_url: "https://eyecare2027.com/api/payment/notify",
        order_id: orderId,
        items: "Conference Registration",
        amount: data.amount,
        currency: data.currency,
        hash: data.hash,
        first_name: formData.firstName,
        last_name: formData.lastName || "",
        email: formData.email,
        phone: formData.phone || "",
        address: formData.address || "",
        city: formData.city || "",
        country: "Sri Lanka",
      });
  
      // Clear previous callbacks
      window.payhere.onCompleted = null;
      window.payhere.onDismissed = null;
      window.payhere.onError = null;
  
      // Set fresh callbacks
      window.payhere.onCompleted = function (completedOrderId) {
        console.log("Payment completed successfully. Redirecting to success page.");
        window.location.href = `/success?order_id=${completedOrderId}`;
      };
  
      window.payhere.onDismissed = function () {
        console.log("User dismissed the payment. Redirecting to cancel page.");
        window.location.href = `/cancel?order_id=${orderId}`;
      };
  
      window.payhere.onError = function (error) {
        console.error("Payment error:", error);
      
        // Redirect to cancel page with appropriate error details
        window.location.href = `/cancel?order_id=${orderId}&error=${encodeURIComponent(error.message || "Payment failed")}`;
      };

    } catch (error) {
      console.error("Payment error during initiation:", error);
      window.location.href = `/cancel?order_id=${orderId}`; // Redirect on initiation failure
      setError(error.message || "Payment failed. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };

  

  


  return (
<>

    <div className="payment-page">


      <h2 className="cert-workshop-title" align="center">Conference Registration</h2>
      {/******card view for single price for participation ******/}

 <div className="payment-page">
  
   <div className="pricing-table-container">
    <table className="pricing-table">
      <thead>
        <tr>
          <th>Participant Type</th>
          <th>
            Early Registration 
            <span className="price-badge" data-tooltip="Register early to save!">SAVE </span>
            <div className="savings-progress" style={{'--savings-percent': ''}}></div>
          </th>
          <th className="best-value">
            Regular 
            <div className="savings-progress" style={{'--savings-percent': '0%'}}></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td data-label="Participant">
          
            International Participant
          </td>
          <td data-label="Until 24th Jan">
            <span className="price-value price-tooltip" data-tooltip="Early bird price">
              $120
            </span>
          </td>
          <td data-label="At Gate" className="best-value">
            <span className="price-value price-tooltip" data-tooltip="Gate price">
              $150
            </span>
          </td>
        </tr>
        <tr>
          <td data-label="Participant">
     
            SAARC Participant
          </td>
          <td data-label="Until 24th Jan">
            <span className="price-value price-tooltip" data-tooltip="Early bird price">
              $100
            </span>
          </td>
          <td data-label="At Gate">
            <span className="price-value price-tooltip" data-tooltip="Gate price">
              $120
            </span>
          </td>
        </tr>
        <tr>
          <td data-label="Participant">
    
            Sri Lankan Participant
          </td>
          <td data-label="Until 24th Jan">
            <span className="price-value price-tooltip" data-tooltip="Early bird price">
              25,000 <span className="currency-indicator">LKR</span>
            </span>
          </td>
          <td data-label="At Gate">
            <span className="price-value price-tooltip" data-tooltip="Gate price">
              30,000 <span className="currency-indicator">LKR</span>
            </span>
          </td>
        </tr>
        <tr>
          <td data-label="Participant">
 
            Sri Lankan Participant: 01 Day
          </td>
          <td data-label="Until 24th Jan">
            <span className="price-value price-tooltip" data-tooltip="Early bird price">
              15,000 <span className="currency-indicator">LKR</span>
            </span>
          </td>
          <td data-label="At Gate">
            <span className="price-value price-tooltip" data-tooltip="Gate price">
              20,000 <span className="currency-indicator">LKR</span>
            </span>
          </td>
        </tr>
        <tr>
          <td data-label="Participant">
  
            Student Registration
          </td>
          <td data-label="Until 24th Jan">
            <span className="price-value price-tooltip" data-tooltip="Early bird price">
              20,000 <span className="currency-indicator">LKR</span>
            </span>
          </td>
          <td data-label="At Gate">
            <span className="price-value price-tooltip" data-tooltip="Gate price">
              20,000 <span className="currency-indicator">LKR</span>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>







      <div className="payment-container">
        {error && (
          <div className="error-message">
            {error}
            <button onClick={() => setError(null)}>×</button>
          </div>
        )}

        <div className="form-section">
          <div className="form-group">
            <label>Participant Category:</label>
            <select value={category} onChange={handleCategoryChange}>
              <option value="">Select Category</option>
              <option value="International Participant">International Participant</option>
              <option value="SARC Participant">SAARC Participant</option>
              <option value="SriLankan Participant">Sri Lankan Participant</option>
               <option value="SriLankan Participant- 01 Day">Sri Lankan Participant - 01 Day</option>
                <option value="Student Registration">Student Registration</option>
            </select>
          </div>

          {amount > 0 && (
            <div className="amount-display">
              <p>Amount: {currency === "USD" ? `$${amount}` : `LKR ${amount.toLocaleString()}`}</p>
            </div>
          )}

          <div className="form-group">
            <label>First Name *</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Phone *</label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Address *</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>City *</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              required
            />
          </div>

          {amount > 0 && (
            <button
              className="pay-button"
              onClick={handlePayment}
              disabled={isProcessing || !formData.firstName || !formData.email || !category}
            >
              {isProcessing ? "Processing..." : "Proceed to Payment"}
            </button>
          )}
        </div>
      </div>
    </div>
    </>
  );
}

export default Payment;